import {Sha256} from '@aws-crypto/sha256-browser';

const hashPassword = (password: string, salt: string) => {
  const hash = new Sha256();
  hash.update(password + salt);
  return hash.digest().then(b => Array.prototype.map.call(b, (x: any) => ('00' + x.toString(16)).slice(-2)).join(''));
};

export default hashPassword;
